import { animate, style, transition, trigger, state } from '@angular/animations';

export const toolbarAnimation = trigger('toolbarCollapsed', [
    state('false', style({
        maxHeight: '{{height}}rem',
        opacity: 1,
        marginBottom: '10px'
    }), {params: {height: 6.25}}),
    state('true', style({
        maxHeight: 0,
        opacity: 0,
        marginBottom: 0
    })),
    transition('true => false', [
        animate('300ms ease-in-out')
    ]),
    transition('false => true', [
        animate('300ms ease-in-out')
    ])
]);
